import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function TransformationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full px-6 py-10 bg-gradient-to-b from-dark-navy via-amber-gold/5 to-dark-navy" data-id="element-250">
      <div className="max-w-3xl mx-auto" data-id="element-251">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-252">
          <div className="flex items-center gap-4 mb-12" data-id="element-253">
            <Sparkles className="w-8 h-8 text-amber-gold" strokeWidth={1.5} data-id="element-254" />
            <h2 className="font-playfair text-3xl md:text-4xl font-bold" data-id="element-255">
              Lo que esto significa para tu vida real
            </h2>
          </div>

          <p className="text-lg md:text-xl mb-12" data-id="element-256">
            No te voy a hablar de características. Te voy a hablar de lo que
            cambia.
          </p>

          <div className="space-y-8" data-id="element-257">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            delay: 0.2,
            duration: 0.6
          }} className="pl-6 border-l-2 border-amber-gold" data-id="element-258">
              <p className="text-lg md:text-xl" data-id="element-259">
                Imagina despertar mañana sin esa sensación de pesadez que lleva
                tanto tiempo siendo lo primero que sientes. No eufórico. Solo...
                descansado. Con la mente limpia.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} className="pl-6 border-l-2 border-amber-gold" data-id="element-260">
              <p className="text-lg md:text-xl" data-id="element-261">
                Imagina llegar a una situación de estrés — una reunión, una
                conversación difícil, un momento de pánico — y tener algo que
                funciona. Un ancla real. No respirar hondo y esperar lo mejor,
                sino activar deliberadamente tu sistema nervioso parasimpático
                en segundos.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            delay: 0.6,
            duration: 0.6
          }} className="pl-6 border-l-2 border-amber-gold" data-id="element-262">
              <p className="text-lg md:text-xl" data-id="element-263">
                Imagina acostarte por la noche sin el ritual de lucha mental que
                llevas meses normalizando. Cerrar los ojos y que tu cuerpo sepa,
                por entrenamiento biológico, que es hora de descansar.
              </p>
            </motion.div>
          </div>

          <p className="text-xl md:text-2xl font-playfair font-semibold mt-12 text-amber-gold" data-id="element-264">
            Eso no es un sueño imposible. Es exactamente lo que pasa cuando tu
            sistema nervioso recibe las señales correctas de forma consistente.
          </p>

          <p className="text-lg md:text-xl mt-8" data-id="element-265">
            Pero hay más. Porque la calma tiene dos velocidades.
          </p>

          <CtaButton text="Quiero dormir profundo y despertar sin ansiedad" variant="secondary" data-id="element-266" />
        </motion.div>
      </div>
    </section>;
}